import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from '@/services/analytics';
import { useContactChannel } from '@/hooks/useContactChannel';

const WhatsAppButton = () => {
  const channel = useContactChannel();

  const openWhatsApp = () => {
    trackWhatsAppClick(window.location.pathname, 'floating_button');
    window.open(channel.whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.button
      onClick={openWhatsApp}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/40 hover:shadow-xl hover:shadow-[#25D366]/50 transition-shadow"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      data-testid="whatsapp-button"
      data-vertical={channel.vertical}
      aria-label={`Chat on WhatsApp — ${channel.whatsappDisplay}`}
    >
      <MessageCircle className="w-8 h-8 text-white" fill="white" />
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
      <motion.span
        className="absolute right-full mr-4 px-4 py-2 bg-white text-gray-800 text-sm font-medium rounded-lg shadow-lg whitespace-nowrap"
        initial={{ opacity: 0, x: 10 }}
        whileHover={{ opacity: 1, x: 0 }}
      >
        Chat with us!
      </motion.span>
    </motion.button>
  );
};

export default WhatsAppButton;
